import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.StartOverPopup', {
    startOverButtonText: 'Restart',
    descriptionText: `
        Restart the approval workflow for this request.
        The Approvers who have already made their decision will need to make it again.{br}{br}
        Please add a comment so that the Approvers know what has happened.
        This is optional.`,
    popupTitle: 'Restart the approval workflow',
    startOverButtonTitle: 'Restart the approval workflow for this request',
});
